import { useQueryClient } from 'shared-ui';
import { toast } from 'react-toastify';

import { QueryKeyEnum } from 'core/global.enum';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { useMutation } from 'hooks/useMutation/useMutation';
import { useSelectedGlc } from 'hooks/useSelectedGlc/useSelectedGlc';
import { archiveMultiGlc } from 'api/glc/glc';
import { useModalState } from 'hooks/useModalState/useModalState';

import { ArchiveMultiGlc } from './ArchiveMultiGlc';
import { ArchiveMultiGlcContainerProps } from './ArchiveMultiGlc.types';

export const ArchiveMultiGlcContainer = ({ checkedGlc, setCheckedGlc }: ArchiveMultiGlcContainerProps) => {
  const queryClient = useQueryClient();
  const { formatMessage } = useLocale();
  const { selectedGlc, setSelectedGlc } = useSelectedGlc();
  const { isModalOpen, onModalOpen, onModalClose } = useModalState();

  const { mutate: onArchiveMultiGlc, isLoading } = useMutation(archiveMultiGlc, {
    onSuccess: () => {
      if (selectedGlc && checkedGlc.some(({ id }) => id === selectedGlc?.id)) {
        setSelectedGlc(undefined);
      }

      queryClient.invalidateQueries([QueryKeyEnum.GLC]);
      toast.dark(formatMessage({ id: AppMessages['glc.multiAction.archive.successMessage'] }));
      setCheckedGlc([]);
      onModalClose();
    },
  });

  const onSubmit = () => {
    onArchiveMultiGlc({ body: checkedGlc.map(({ id }) => id) });
  };

  return (
    <ArchiveMultiGlc
      checkedGlc={checkedGlc}
      isModalOpen={isModalOpen}
      onModalClose={onModalClose}
      onModalOpen={onModalOpen}
      isLoading={isLoading}
      onSubmit={onSubmit}
    />
  );
};
